import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { signInWithEmailAndPassword, onAuthStateChanged } from 'firebase/auth';
import { auth } from '../../src/pages/app/protected/firebase'; // adjust to your config

export default function AdminLogin() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      const adminUIDs = import.meta.env.VITE_ADMIN_UIDS?.split(',') || [];
  
      if (user && adminUIDs.includes(user.uid)) {
        navigate('/admin/dashboard');
      } else if (user) {
        auth.signOut(); // force logout
        setError("Unauthorized access: Not an admin.");
      }
    });
  
    return () => unsubscribe();
  }, [navigate]);

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      const result = await signInWithEmailAndPassword(auth, email, password);
      const uid = result.user.uid;

      const adminUIDs = import.meta.env.VITE_ADMIN_UIDS?.split(',') || [];
      if (adminUIDs.includes(uid)) {
        navigate('/admin/dashboard');
      } else {
        await auth.signOut();
        setError("Unauthorized: You are not an admin.");
      }
    } catch (err) {
      setError("Login failed. Please check your credentials.");
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100 px-4">
      <div className="max-w-md w-full bg-white p-8 rounded-xl shadow">
        <h2 className="text-2xl font-bold mb-6 text-center">Admin Login</h2>
        {error && <p className="text-red-500 mb-4">{error}</p>}
        <form onSubmit={handleLogin} className="space-y-4">
          <input
            type="email"
            placeholder="Admin Email"
            className="w-full border px-4 py-2 rounded"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
          <input
            type="password"
            placeholder="Password"
            className="w-full border px-4 py-2 rounded"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
          <button
            type="submit"
            className="w-full bg-black text-white py-2 rounded hover:opacity-80"
          >
            Login
          </button>
        </form>
      </div>
    </div>
  );
}